import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "flex-direction"
    }}>{`flex-direction`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v3.0`}</p>
    <p>{`Determines the direction items are stacked in the flexible container. The default is `}<inlineCode parentName="p">{`row`}</inlineCode>{`, and `}<inlineCode parentName="p">{`row`}</inlineCode>{`, `}<inlineCode parentName="p">{`row-reverse`}</inlineCode>{`, `}<inlineCode parentName="p">{`column`}</inlineCode>{`, and `}<inlineCode parentName="p">{`column-reverse`}</inlineCode>{` are supported.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/flex-direction"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/flex-direction`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    flex-basis: column;
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      